import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "../common/LanguageSwitcher";

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const navLinks = [
  { to: "/features", labelKey: "nav.features" },
  { to: "/downloads", labelKey: "nav.downloads" },
  { to: "/future", labelKey: "nav.future" },
  { to: "/known-issues", labelKey: "nav.knownIssues" },
  { to: "/changelog", labelKey: "nav.changelog" },
  { to: "/docs", labelKey: "nav.docs" },
];

export function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="md:hidden absolute top-16 left-0 right-0 bg-dark-card border-b border-dark-border">
      <nav className="flex flex-col py-4">
        {navLinks.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            onClick={onClose}
            className={({ isActive }) =>
              `px-4 py-3 text-sm font-medium transition-colors ${
                isActive
                  ? "text-warm-50 bg-dark-hover"
                  : "text-warm-500 hover:text-warm-100 hover:bg-dark-hover"
              }`
            }
          >
            {t(link.labelKey)}
          </NavLink>
        ))}
        <div className="px-4 pt-4 mt-2 border-t border-dark-border">
          <LanguageSwitcher />
        </div>
      </nav>
    </div>
  );
}
